module.exports = __webpack_public_path__ + "static/media/mito36.36fa2b10.jpg";